declare var pdfjsLib: any;

namespace Serenity {
    export namespace UploadHelper {
        import text = Q.text;

        export function addUploadInput(options: UploadInputOptions): JQuery {
            options.container.addClass("fileinput-button");
            const
                validation = options.validation;

            var uploadInput = $('<input/>').attr('type', 'file')
                .attr('name', options.inputName + '[]')
                .attr('data-url', Q.resolveUrl('~/File/TemporaryUpload'))
                .attr('multiple', 'multiple').appendTo(options.container);

            if (options.allowMultiple) {
                uploadInput.attr("multiple", "multiple");
            }

            (uploadInput as any).fileupload({
                dataType: "json",
                dropZone: options.zone,
                pasteZone: options.zone,
                paramName: name,
                formAcceptCharset: "UTF-8",
                // sequentialUploads: true,
                // autoUpload: false,
                processQueue: [{
                    action: "validate",
                    always: true,
                    minSize: validation.minSize,
                    maxSize: validation.maxSize,
                },],
                done: function (event: JQueryEventObject, data: any) {
                    const response = data.result;

                    if (options.fileDone) {
                        options.fileDone(response, data.files[0].name, data);
                    }
                },
                progress: function (event: JQueryEventObject, data: any) {
                    if (!options.progress) {
                        return;
                    }

                    options.progress.find(":first-child").css("width", `${(data.loaded / data.total) * 100}%`);
                },
                start: function (event: JQueryEventObject) {
                    Q.blockUI(null);

                    if (!options.progress) {
                        return;
                    }

                    options.progress.show();
                },
                stop: function () {
                    Q.blockUndo();

                    if (!options.progress) {
                        return;
                    }

                    options.progress.hide();
                },
                processfail: function (event: JQueryEventObject, data: any) {
                    if (!data.files.error) {
                        return;
                    }

                    data.files.forEach((file: any, index: any, files: Array<any>) => {
                        Q.notifyError(file.error);
                    });
                },
                fail: function (event: JQueryEventObject, data: any) {
                    var message = data?.jqXHR?.responseJSON?.Error.Message || "خطا";
                    data.files.forEach((file: any, index: any, files: Array<any>) => {
                        Q.notifyError(`'${file.name}' : ${message}`);
                    });
                },

            });

            return uploadInput;
        }

        // export function checkImageConstraints(file: UploadResponse, opt: ImageUploadEditorOptions): boolean {
        //     if (opt.minWidth > 0 && file.Width < opt.minWidth) {
        //         Q.alert(Q.format(Q.text("Controls.ImageUpload.MinWidth"), opt.minWidth));
        //
        //         return false;
        //     }
        //
        //     if (opt.maxWidth > 0 && file.Width > opt.maxWidth) {
        //         Q.alert(Q.format(Q.text("Controls.ImageUpload.MaxWidth"), opt.maxWidth));
        //
        //         return false;
        //     }
        //
        //     if (opt.minHeight > 0 && file.Height < opt.minHeight) {
        //         Q.alert(Q.format(Q.text("Controls.ImageUpload.MinHeight"), opt.minHeight));
        //
        //         return false;
        //     }
        //
        //     if (opt.maxHeight > 0 && file.Height > opt.maxHeight) {
        //         Q.alert(Q.format(Q.text("Controls.ImageUpload.MaxHeight"), opt.maxHeight));
        //
        //         return false;
        //     }
        //
        //     return true;
        // }

        export function fileSizeDisplay(bytes: number): string {
            var byteSize = (ss as any).round(bytes * 100 / 1024) * .01,
                suffix = "KB";

            if (byteSize >= 1024) {
                byteSize = (ss as any).round(byteSize * 100 / 1024) * .01;
                suffix = "MB";
            }

            var sizeParts = byteSize.toString().split(String.fromCharCode(46)),
                value;

            if (sizeParts.length > 1) {
                value = `${sizeParts[0]}.${sizeParts[1].substr(0, 2)}`;
            } else {
                value = sizeParts[0];
            }

            return `${value} ${suffix}`;
        }

        export function fileNameSizeDisplay(name: string, bytes: number): string {
            return `${name} (${fileSizeDisplay(bytes)})`;
        }

        export function getTypeByExtension(filename: string): FileType | null {
            if (!filename || typeof filename !== "string") {
                return null;
            }

            let index: number = filename.lastIndexOf(".");

            if (index === -1) {
                return null;
            }

            let extension: string = filename.substring(index + 1);

            // @ts-ignore
            if (!filename.endsWith(`.${extension}`)) {
                return null;
            }

            switch (extension) {
                case "jpeg":
                case "jpg":
                case "jpe":
                // case "jfif":
                case "png":
                case "bmp":
                // case "dib":
                case "tiff":
                case "tif":
                case "webp":
                case "ico":
                case "svg":
                case "gif":
                    // case "heic":
                    // case "ai":
                    // case "ps":
                    // case "psd":
                    return FileType.Image;

                case "pdf":
                    return FileType.PDF;

                case "doc":
                case "docx":
                case "odt":
                case "rtf":
                case "tex":
                case "txt":
                case "wks":
                case "wps":
                case "wpd":
                /* Spreadsheet */
                case "ods":
                case "xlr":
                case "xls":
                case "xlsx":
                /* Presentation */
                case "key":
                case "odp":
                case "pps":
                case "ppt":
                case "pptx":
                    return FileType.Document;

                // case "7z":
                // case "rar":
                // // case "tar.gz":
                // case "z":
                // case "zip":
                //     return FileType.Compressed;

                case "csv":
                    // case "dat":
                    // case "db":
                    // case "dbf":
                    // case "log":
                    // case "mdb":
                    // case "sav":
                    // case "sql":
                    // case "tar":
                    // case "xml":
                    return FileType.Data;

                case "apk":
                case "bin":
                    return FileType.Exe;

                case "fnt":
                case "fon":
                case "otf":
                case "ttf":
                    return FileType.Font;
            }

            return null;
        }

        export function getExtensionsByType(fileType: FileType): string {
            // Image = 0,
            //     PDF = 1 << 0,
            //     Document = 1 << 1,
            //     Data = 1 << 2,
            //     Compressed = 1 << 3,
            //     Exe = 1 << 4,
            //     Font = 1 << 5,

            switch (fileType) {
                case Serenity.FileType.Image:
                    return "";
                case Serenity.FileType.PDF:
                    return "";
                case Serenity.FileType.Document:
                    return "";
                case Serenity.FileType.Data:
                    return "";
                case Serenity.FileType.Compressed:
                    return "";
                // case Serenity.FileType.Exe:
                //     return "";
                // case Serenity.FileType.Font:
                //     return "";
            }
        }

        export function thumbFileName(filename: string): string {
            filename = filename || "";
            const index = filename.lastIndexOf(".");

            if (index >= 0) {
                filename = filename.substr(0, index);
            }

            return `${filename}_t.jpg`;
        }

        export function dbFileUrl(filename: string): string {
            filename = Q.replaceAll((filename || ""), "\\", "/");

            return Q.resolveUrl("~/upload/") + filename;
        }

        /*function colorBox(anchor: JQuery, options: any = {}): void {
            (anchor as any).colorbox($.extend({}, options, {
                current: Q.text("Controls.ImageUpload.ColorboxCurrent"),
                previous: Q.text("Controls.ImageUpload.ColorboxPrior"),
                next: Q.text("Controls.ImageUpload.ColorboxNext"),
                close: Q.text("Controls.ImageUpload.ColorboxClose"),
            }));
        }*/

        function setPreview(type: FileType, parameters: PreviewProps): JQuery {
            if (type == null || (!parameters || typeof parameters !== "object")) {
                return;
            }

            let url: string,
                $dialog: any;
            // @ts-ignore
            const { element, options: { name, tempAddress }, } = parameters;

            switch (type) {
                case Serenity.FileType.Image:
                    element.css("backgroundImage", `url('${dbFileUrl(thumbFileName(tempAddress))}')`);
                    $dialog = Q.iframeDialog({
                        html: `<img src="${dbFileUrl(tempAddress)}" title="${name}" alt="${name}" style="display: block; max-width: 100%; max-height: 100%; margin: 0 auto;" />`,
                        dialogTitleKey: "Controls.ImageUpload.Preview",
                        autoOpen: false,
                    });
                    // colorBox(element, {
                    //     rel: "group",
                    // });
                    // element.attr("title", `${text("Controls.ImageUpload.Preview")} ${name}`);

                    break;
                case Serenity.FileType.PDF:
                case Serenity.FileType.Document:
                case Serenity.FileType.Data:
                    url = dbFileUrl(tempAddress);
                    // getPDF(url);
                    $dialog = Q.iframeDialog({
                        // src: `/layouts/doc-viewer.html#${href}`,
                        src: `${url}#toolbar=0`,
                        dialogTitleKey: "Controls.ImageUpload.Preview",
                        autoOpen: false,
                    });

                    break;
                default:
                    element.on("click", function (event: JQueryEventObject) {
                        event.preventDefault();
                    });

                    return;
            }

            element.attr("title", `${text("Controls.ImageUpload.Preview")} ${name}`)
                .on("click", function (event: JQueryEventObject) {
                    event.preventDefault();
                    $dialog.dialog("open");
                });

            return $dialog;
        }

        function getPDF(url: string) {
            pdfjsLib.getDocument(url).promise.then(function (pdf: any) {
                pdf.getPage(1).then(function (page: any) {
                    const viewport = page.viewport({
                        scale: 1.5,
                    });

                });
            }).catch(function (error: any) {
                alert(error.message);
            });
        }

        export function populateFileSymbols(container: JQuery, entities: UploadedFile[] = [], displayOriginalName?: boolean, urlPrefix?: string, reference?: ImageUploadEditor | MultipleImageUploadEditor): void {
            destroySymbols(container);
            const items = entities || [],
                instance = !(reference instanceof ImageUploadEditor || reference instanceof MultipleImageUploadEditor) ? null : reference;

            items.forEach((item, index) => {
                const type: FileType = getTypeByExtension(item.Filename),
                    $li = $("<li />", {
                        class: `file-item file-${(type === FileType.Image) ? "image" : "document"}`,
                    }).data("index", index),
                    $thumb = $("<a />", {
                        class: "thumb",
                    }).appendTo($li),
                    $footer = $("<div />", {
                        class: "file-footer",
                    }).appendTo($li),
                    $action = $("<div />", {
                        class: "file-actions",
                    });

                let originalName = item.OriginalName || "",
                    fileName = item.Filename;

                if (urlPrefix && fileName && !(fileName as any).startsWith("temporary/")) {
                    fileName = urlPrefix + fileName;
                }

                $thumb.attr("href", dbFileUrl(fileName));

                if (originalName) {
                    $thumb.attr("title", originalName);
                }

                const previewOptions: PreviewProps = {
                    element: $thumb,
                    options: {
                        name: originalName,
                        tempAddress: fileName,
                    },
                };

                const $previewElement = setPreview(type, previewOptions);

                if ($previewElement && $previewElement.length) {
                    $li.data("preview", $previewElement);
                }

                if (displayOriginalName) {
                    $("<p />", {
                        class: "file-name",
                        text: originalName,
                    }).appendTo($footer);
                }

                $action.appendTo($footer);
                $("<button />", {
                    class: "action-button download-button",
                    type: "button",
                    title: text("Controls.ImageUpload.DownloadButton") + ((originalName) ? ` ${originalName}` : ""),
                }).appendTo($action).on("click", event => {
                    event.preventDefault();

                    if (!$thumb.length) {
                        return;
                    }

                    const dl_anchor = document.createElement("a");
                    dl_anchor.href = $thumb.attr("href");

                    if (originalName) {
                        dl_anchor.download = originalName;
                    }

                    dl_anchor.dispatchEvent(new MouseEvent("click"));
                });
                $("<button />", {
                    class: "action-button delete-button",
                    type: "button",
                    title: text("Controls.ImageUpload.DeleteButton") + ((originalName) ? ` ${originalName}` : ""),
                }).appendTo($action).on("click", event => {
                    event.preventDefault();

                    if (instance && typeof instance === "object") {
                        const ins = (instance as any);

                        if (ins.entity) {
                            ins.entity = null;
                        } else if (ins.entities) {
                            (ss as any).removeAt(ins.entities, index);
                        } else {
                            return;
                        }

                        ins.populate();
                    }
                });

                $li.appendTo(container);
            });
        }

        function destroySymbols($container: JQuery) {
            if (!$container || !$container.length) {
                return;
            }

            $container.children().each(function (index, elem) {
                const $preview = $(elem).data("preview");

                if (!$preview || !$preview.length) {
                    return;
                }

                $preview.dialog("destroy");
            });

            $container.html("");
        }
    }

    export enum FileType {
        Image = 0,
        PDF = 1 << 0,
        Document = 1 << 1,
        Data = 1 << 2,
        Compressed = 1 << 3,
        Exe = 1 << 4,
        Font = 1 << 5,
    }

    export interface UploadedFile {
        Filename?: string;
        OriginalName?: string;
    }

    export interface UploadInputOptions {
        container?: JQuery;
        inputName?: string;
        zone?: JQuery;
        progress?: JQuery;
        allowMultiple?: boolean;
        validation?: UploadValidation;
        fileDone?: (p1: UploadResponse, p2: string, p3: any) => void;
    }

    export interface UploadValidation {
        minSize?: number;
        maxSize?: number;
    }

    export interface UploadResponse {
        TemporaryFile: string;
        Size: number;
        Width: number;
        Height: number;
    }

    export interface PreviewProps {
        element: JQuery;
        options: PreviewPropsOptions;
    }

    export interface PreviewPropsOptions {
        name: string;
        tempAddress: string;
    }
}